import { render, staticRenderFns } from "./BulkReport.vue?vue&type=template&id=64b60130&scoped=true&"
import script from "./BulkReport.vue?vue&type=script&lang=js&"
export * from "./BulkReport.vue?vue&type=script&lang=js&"
import style0 from "./BulkReport.vue?vue&type=style&index=0&id=64b60130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b60130",
  null
  
)

component.options.__file = "BulkReport.vue"
export default component.exports